<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs pos-relative lift-chart-report"
  style="min-height: 27.5em;">
  <app-loader [showLoader]=showLoad></app-loader>
  <div>

    <div style="width: 100%; height: 100%;" *ngIf="hasData">
      <div class="lift-chart" appTooltip title="Tooltip" [title]="campaignCarouselItem?.name" data-placement="top" data-size="small" [options]="tooltipOptions">
        <div class="o-stack__cell lift-title">
          <h5 *ngIf="sectionclass != 'V6_preroll_lift_trend'">DISPLAY LIFT: {{campaignCarouselItem?.name | uppercase}}</h5>
          <h5 *ngIf="sectionclass == 'V6_preroll_lift_trend'">{{sectiontitle}} {{campaignCarouselItem?.name | uppercase}}</h5>
        </div>

        <div class="o-stack__cell tinyGap u-font-small navigation_arrows"
             *ngIf="campaignsList.length > 1 && isR6Enabled">
          <div class="left_arrow">
            <a href="javascript:void(null)">
              <img (click)="prevArrow()" src="../../../../../assets/images/left_arrow.svg"/>
            </a>
          </div>
          <div class="right_arrow">
            <a href="javascript:void(null)">
              <img (click)="nextArrow()" src="../../../../../assets/images/right_arrow.svg"/>
            </a>
          </div>
        </div>
      </div>
      <div>
        <div class="c-portlet__content u-pt-small" style="width:100%;" *ngIf="campaignCarouselItem">
          <div class="o-stack o-stack--center  o-stact_ImgSpecs" style="height: auto;">
            <div class="charts-container product-lift-chart-container" style="margin: 0 auto; width:100%">
              <div class="chart-layout">
                <div [id]="'campaign'+i" class="individual-chart" style="min-height: 200px;">
                  <app-chart class="individual-chart" [setcolor]="setGraphBackgroundColor"
                    [chartData]="campaignCarouselItem"></app-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-data-container" *ngIf="!hasData">
      <div class="lift-chart">
        <div class="o-stack__cell">
          <h5 *ngIf="sectionclass != 'V6_preroll_lift_trend'">DISPLAY LIFT</h5>
          <h5 *ngIf="sectionclass == 'V6_preroll_lift_trend'">{{sectiontitle}}</h5>
        </div>
      </div>
      <div class="map-no-data"><img [src]="placeholderimage" class="lift-trend-no-data-placeholder" /></div>
    </div>
  </div>
</div>
